export default __webpack_public_path__ + "static/media/avatar-default.d011667d.png";